import cn from 'classnames'
import React, { ComponentProps } from 'react'

type PolicyInsightThumbsDownIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function PolicyInsightThumbsDownIcon(
  props: PolicyInsightThumbsDownIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('PolicyInsightThumbsDownIcon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M10.5924 2.6665V8.53317M13.3334 6.8265V4.37317C13.3334 3.77578 13.3334 3.47709 13.2139 3.24891C13.1087 3.04821 12.941 2.88503 12.7347 2.78276C12.5002 2.6665 12.1932 2.6665 11.5792 2.6665H5.72342C4.92225 2.6665 4.52167 2.6665 4.19813 2.80914C3.91297 2.93484 3.67062 3.13713 3.49955 3.39222C3.30545 3.68165 3.24454 4.06684 3.12272 4.83724L2.83597 6.65057C2.6753 7.66667 2.59496 8.17472 2.74994 8.57004C2.88596 8.91701 3.14181 9.20714 3.47361 9.3907C3.85164 9.59984 4.37999 9.59984 5.43668 9.59984H5.878C6.18502 9.59984 6.33852 9.59984 6.45579 9.65797C6.55894 9.7091 6.6428 9.79069 6.69535 9.89104C6.7551 10.0051 6.7551 10.1545 6.7551 10.4532V12.0181C6.7551 12.7444 7.3603 13.3332 8.10685 13.3332C8.28491 13.3332 8.44627 13.2311 8.51859 13.0728L10.3609 9.03993C10.4447 8.8565 10.4866 8.76479 10.5528 8.69754C10.6114 8.63809 10.6833 8.59264 10.7629 8.56474C10.8529 8.53317 10.9561 8.53317 11.1624 8.53317H11.5792C12.1932 8.53317 12.5002 8.53317 12.7347 8.41691C12.941 8.31465 13.1087 8.15147 13.2139 7.95076C13.3334 7.72259 13.3334 7.42389 13.3334 6.8265Z" />
    </svg>
  )
}
